import { render, staticRenderFns } from "./ReasonRejectInfo.vue?vue&type=template&id=f1d1b0c6&scoped=true&"
import script from "./ReasonRejectInfo.vue?vue&type=script&lang=js&"
export * from "./ReasonRejectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReasonRejectInfo.vue?vue&type=style&index=0&id=f1d1b0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d1b0c6",
  null
  
)

export default component.exports